<template>
  <div
    v-if="version === 'v1'"
    class="property-list-item tw-flex tw-flex-col tw-border-2 tw-p-4 tw-text-start md:tw-min-h-[600px]"
    style="border-radius: var(--rounded)"
  >
    <nuxt-link :external="true" :to="property.detail_page_url" class="n-link tw-relative">
      <library-image
        :src="property.image"
        :quality="60"
        style="border-radius: var(--rounded)"
        :blur="imageBlurFilter"
        :pre-market-blur-text="preMarketBlurText"
      />
      <div v-if="property.custom_property_status_title && !property.is_locked" class="nc-property-image-badge">
        {{ property.custom_property_status_title }}
      </div>
    </nuxt-link>
    <div class="tw-flex tw-flex-col tw-gap-4 tw-pt-4">
      <h4 class="tw-line-clamp-2 tw-h-[3.6rem]">
        {{ property.display_address }}
      </h4>
      <div class="tw-flex tw-items-center tw-justify-between">
        <div>
          <p v-if="property.price.type.name">{{ property.price.type.name }}</p>
          <h6>{{ property.price.price }}</h6>
        </div>
        <div v-if="property.match_percentage && !isMatchInformationHidden" class="tw-flex tw-items-center tw-gap-2">
          <button
            class="n-primary !tw-cursor-default !tw-px-2 !tw-py-1 hover:!tw-bg-[var(--c-secondary)] hover:!tw-text-white"
          >
            <p>{{ property.match_percentage }} MATCH</p>
          </button>
        </div>
      </div>
      <div class="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-pt-4">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10 11.25C9.38193 11.25 8.77775 11.0667 8.26384 10.7233C7.74994 10.38 7.3494 9.89191 7.11288 9.32089C6.87635 8.74987 6.81447 8.12154 6.93505 7.51534C7.05563 6.90915 7.35325 6.35233 7.79029 5.91529C8.22733 5.47825 8.78415 5.18063 9.39034 5.06005C9.99654 4.93947 10.6249 5.00135 11.1959 5.23788C11.7669 5.4744 12.255 5.87494 12.5983 6.38884C12.9417 6.90275 13.125 7.50693 13.125 8.125C13.124 8.9535 12.7945 9.74778 12.2086 10.3336C11.6228 10.9195 10.8285 11.249 10 11.25ZM10 6.25C9.62916 6.25 9.26665 6.35997 8.95831 6.566C8.64997 6.77202 8.40964 7.06486 8.26773 7.40747C8.12581 7.75008 8.08868 8.12708 8.16103 8.4908C8.23338 8.85451 8.41195 9.1886 8.67418 9.45083C8.9364 9.71305 9.27049 9.89163 9.63421 9.96397C9.99792 10.0363 10.3749 9.99919 10.7175 9.85728C11.0601 9.71536 11.353 9.47504 11.559 9.1667C11.765 8.85835 11.875 8.49584 11.875 8.125C11.8745 7.62787 11.6768 7.15125 11.3253 6.79972C10.9738 6.4482 10.4971 6.2505 10 6.25Z"
            fill="black"
          />
          <path
            d="M10 18.75L4.72751 12.5319C4.65425 12.4385 4.58174 12.3445 4.51001 12.25C3.60937 11.0636 3.12282 9.61452 3.12501 8.125C3.12501 6.30164 3.84934 4.55295 5.13865 3.26364C6.42796 1.97433 8.17664 1.25 10 1.25C11.8234 1.25 13.5721 1.97433 14.8614 3.26364C16.1507 4.55295 16.875 6.30164 16.875 8.125C16.8772 9.61384 16.3909 11.0623 15.4906 12.2481L15.49 12.25C15.49 12.25 15.3025 12.4963 15.2744 12.5294L10 18.75ZM5.50813 11.4969C5.50813 11.4969 5.65376 11.6894 5.68688 11.7306L10 16.8175L14.3188 11.7237C14.3463 11.6894 14.4925 11.4956 14.4931 11.495C15.2289 10.5257 15.6265 9.34189 15.625 8.125C15.625 6.63316 15.0324 5.20242 13.9775 4.14752C12.9226 3.09263 11.4918 2.5 10 2.5C8.50816 2.5 7.07742 3.09263 6.02253 4.14752C4.96764 5.20242 4.37501 6.63316 4.37501 8.125C4.3737 9.34265 4.77174 10.5271 5.50813 11.4969Z"
            fill="black"
          />
        </svg>
        <p>{{ property.display_address }}</p>
      </div>
      <div class="tw-flex tw-flex-row tw-items-center tw-gap-4">
        <p>Beds: {{ property.bedroom }}</p>
        <p>Baths: {{ property.bathroom }}</p>
        <p>Receptions: {{ property.reception }}</p>
      </div>
    </div>
  </div>

  <div
    v-if="version === 'v2'"
    class="property-list-item tw-group tw-relative tw-flex tw-flex-col tw-p-4 tw-text-start md:tw-min-h-[647px]"
    style="border-radius: var(--rounded); color: var(--c-text-primary); border: 1px solid var(--c-border)"
  >
    <nuxt-link :external="true" :to="property.detail_page_url" class="n-link">
      <div style="border-radius: var(--rounded-sm)">
        <library-image :src="property.image" :blur="imageBlurFilter" :pre-market-blur-text="preMarketBlurText" />
      </div>
      <button
        v-if="property.custom_property_status_title && !property.is_locked"
        class="nc-property-image-badge n-primary tw-z-40"
      >
        {{ property.custom_property_status_title }}
      </button>
    </nuxt-link>
    <div
      v-if="property.featured_video && !property.is_locked"
      class="tw-absolute tw-right-8 tw-top-8 tw-z-40 tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-lg tw-duration-300 hover:tw-scale-95 group-hover:tw-bg-white group-hover:tw-p-3"
      @click="$emit('open-video-popup', property.featured_video)"
    >
      <h6 class="tw-opacity-0 tw-duration-300 group-hover:tw-opacity-100">Play video</h6>
      <div class="tw-rounded-lg tw-bg-white tw-p-3 tw-duration-300 group-hover:tw-bg-transparent group-hover:tw-p-0">
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_84_94)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6 4.5C5.20435 4.5 4.44129 4.81607 3.87868 5.37868C3.31607 5.94129 3 6.70435 3 7.5V28.5C3 29.2956 3.31607 30.0587 3.87868 30.6213C4.44129 31.1839 5.20435 31.5 6 31.5H30C30.7956 31.5 31.5587 31.1839 32.1213 30.6213C32.6839 30.0587 33 29.2956 33 28.5V7.5C33 6.70435 32.6839 5.94129 32.1213 5.37868C31.5587 4.81607 30.7956 4.5 30 4.5H6ZM12.9375 12.945C12.9708 12.6582 13.0706 12.3832 13.2291 12.1419C13.3875 11.9005 13.6002 11.6996 13.8501 11.555C14.1 11.4105 14.3802 11.3263 14.6684 11.3093C14.9566 11.2923 15.2448 11.3429 15.51 11.457C16.266 11.781 17.862 12.51 19.884 13.677C21.305 14.4892 22.6774 15.3837 23.994 16.356C24.2255 16.5283 24.4135 16.7522 24.543 17.0101C24.6726 17.2679 24.74 17.5525 24.74 17.841C24.74 18.1295 24.6726 18.4141 24.543 18.6719C24.4135 18.9298 24.2255 19.1537 23.994 19.326C22.6773 20.2973 21.305 21.1908 19.884 22.002C18.4706 22.8276 17.0101 23.5699 15.51 24.225C15.2448 24.3395 14.9566 24.3903 14.6683 24.3734C14.38 24.3566 14.0996 24.2725 13.8496 24.1278C13.5996 23.9832 13.3869 23.7821 13.2285 23.5406C13.0702 23.2991 12.9705 23.0239 12.9375 22.737C12.7575 21.1113 12.6694 19.4767 12.6735 17.841C12.6735 15.5145 12.8415 13.7625 12.9375 12.945Z"
              fill="var(--c-secondary)"
            />
          </g>
          <defs>
            <clipPath id="clip0_84_94">
              <rect width="36" height="36" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
    <div class="tw-flex tw-flex-col tw-gap-4 tw-pt-4">
      <h4 class="tw-line-clamp-3 tw-h-[5.8rem]">
        {{ property.advert_heading }}
      </h4>

      <template v-if="!property.is_locked">
        <div class="tw-flex tw-h-[72px] tw-items-center tw-justify-between">
          <div>
            <p v-if="property.price.type.name">
              {{ property.price.type.name }}
            </p>
            <h5>{{ property.price.price }}</h5>
          </div>
          <div v-if="property.match_percentage && !isMatchInformationHidden" class="tw-flex tw-items-center tw-gap-2">
            <button
              class="n-primary !tw-cursor-default !tw-px-2 !tw-py-1 hover:!tw-bg-[var(--c-secondary)] hover:!tw-text-white"
            >
              <p>{{ property.match_percentage }} MATCH</p>
            </button>
          </div>
        </div>
        <div class="tw-flex tw-h-16 tw-flex-row tw-items-center tw-gap-2">
          <span>
            <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.945 17.18C11.1238 15.2625 15 11.345 15 7.75C15 5.76088 14.2098 3.85322 12.8033 2.4467C11.3968 1.04018 9.48912 0.25 7.5 0.25C5.51088 0.25 3.60322 1.04018 2.1967 2.4467C0.790176 3.85322 2.96403e-08 5.76088 0 7.75C0 11.345 3.875 15.2625 6.055 17.18C6.45264 17.5349 6.967 17.7311 7.5 17.7311C8.033 17.7311 8.54736 17.5349 8.945 17.18ZM5 7.75C5 7.08696 5.26339 6.45107 5.73223 5.98223C6.20107 5.51339 6.83696 5.25 7.5 5.25C8.16304 5.25 8.79893 5.51339 9.26777 5.98223C9.73661 6.45107 10 7.08696 10 7.75C10 8.41304 9.73661 9.04893 9.26777 9.51777C8.79893 9.98661 8.16304 10.25 7.5 10.25C6.83696 10.25 6.20107 9.98661 5.73223 9.51777C5.26339 9.04893 5 8.41304 5 7.75Z"
                fill="black"
              />
            </svg>
          </span>

          <p>{{ property.display_address }}</p>
        </div>
        <div class="tw-flex tw-flex-row tw-items-center tw-gap-4">
          <p>
            Beds: <span class="tw-font-bold">{{ property.bedroom }}</span>
          </p>
          <p>
            Baths: <span class="tw-font-bold">{{ property.bathroom }}</span>
          </p>
          <p>
            Receptions:
            <span class="tw-font-bold">{{ property.reception }}</span>
          </p>
        </div>
      </template>
      <template v-else-if="property.is_locked">
        <p>
          This is a pre-market property. You need to create an account and register to our property alerts in order to
          view it.
        </p>
        <div class="tw-mt-10 tw-flex tw-gap-x-2 tw-pb-3">
          <nuxt-link :to="routes.REGISTER" class="n-secondary tw-w-fit" :external="true">Register</nuxt-link>
          <nuxt-link
            :to="`${routes.PROPERTY_DETAIL.replace(':propertyId', property.property_profile_id)}#login`"
            class="n-secondary tw-w-fit"
            :external="true"
            >Login</nuxt-link
          >
        </div>
      </template>
    </div>
  </div>

  <div
    v-if="version === 'v3'"
    class="property-list-item tw-group tw-relative tw-flex tw-flex-col tw-p-4 tw-text-start md:tw-min-h-[570px]"
    style="border-radius: var(--rounded); color: var(--c-text-primary)"
  >
    <nuxt-link
      :external="true"
      :to="property.detail_page_url"
      class="n-link tw-overflow-hidden"
      style="border-radius: var(--rounded)"
    >
      <div style="border-radius: var(--rounded)">
        <library-image :src="property.image" :blur="imageBlurFilter" :pre-market-blur-text="preMarketBlurText" />
      </div>

      <button
        v-if="property.custom_property_status_title && !property.is_locked"
        class="nc-property-image-badge n-primary tw-z-40"
      >
        {{ property.custom_property_status_title }}
      </button>
    </nuxt-link>

    <!-- Video Badge -->
    <div
      v-if="property.featured_video && !property.is_locked"
      class="tw-absolute tw-right-8 tw-top-8 tw-z-40 tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-lg tw-duration-300 hover:tw-scale-95 group-hover:tw-bg-white group-hover:tw-p-3"
      @click="$emit('open-video-popup', property.featured_video)"
    >
      <h6 class="tw-opacity-0 tw-duration-300 group-hover:tw-opacity-100">Play video</h6>
      <div class="tw-rounded-lg tw-bg-white tw-p-3 tw-duration-300 group-hover:tw-bg-transparent group-hover:tw-p-0">
        <!-- (mevcut play ikonunuz) -->
        <!-- ... -->
      </div>
    </div>

    <div class="tw-flex tw-flex-col tw-gap-4 tw-pt-8">
      <!-- Başlık + Sağda Fiyat -->
      <div class="tw-flex tw-items-start tw-justify-between tw-gap-4">
        <h5 class="tw-line-clamp-3 tw-max-h-[5.2rem] tw-flex-1">
          {{ property.advert_heading }}
        </h5>

        <div v-if="!property.is_locked" class="tw-shrink-0 tw-text-right">
          <h6 v-if="property.price.type.name" class="tw-uppercase tw-opacity-100">
            {{ property.price.type.name }}
          </h6>
          <h4 class="tw-mt-1 tw-text-[var(--c-primary)]">
            {{ property.price.price }}
          </h4>
        </div>
      </div>

      <template v-if="!property.is_locked">
        <!-- Adres -->
        <div class="tw-flex tw-h-16 tw-flex-row tw-items-center tw-gap-2">
          <span aria-hidden="true" class="tw-inline-flex tw-items-center">
            <!-- Location SVG (renk: --c-primary) -->
            <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.945 17.18C11.1238 15.2625 15 11.345 15 7.75C15 5.76088 14.2098 3.85322 12.8033 2.4467C11.3968 1.04018 9.48912 0.25 7.5 0.25C5.51088 0.25 3.60322 1.04018 2.1967 2.4467C0.790176 3.85322 2.96403e-08 5.76088 0 7.75C0 11.345 3.875 15.2625 6.055 17.18C6.45264 17.5349 6.967 17.7311 7.5 17.7311C8.033 17.7311 8.54736 17.5349 8.945 17.18ZM5 7.75C5 7.08696 5.26339 6.45107 5.73223 5.98223C6.20107 5.51339 6.83696 5.25 7.5 5.25C8.16304 5.25 8.79893 5.51339 9.26777 5.98223C9.73661 6.45107 10 7.08696 10 7.75C10 8.41304 9.73661 9.04893 9.26777 9.51777C8.79893 9.98661 8.16304 10.25 7.5 10.25C6.83696 10.25 6.20107 9.98661 5.73223 9.51777C5.26339 9.04893 5 8.41304 5 7.75Z"
                fill="var(--c-primary)"
              />
            </svg>
          </span>
          <p class="tw-line-clamp-1">{{ property.display_address }}</p>
        </div>

        <!-- Özellikler -->
        <div class="tw-mt-1 tw-flex tw-flex-row tw-items-center tw-gap-6">
          <!-- Beds -->
          <div class="tw-flex tw-items-center tw-gap-2">
            <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 13.5V8.5C0 8.05 0.0916668 7.64167 0.275 7.275C0.458333 6.90833 0.7 6.58333 1 6.3V3.5C1 2.66667 1.29167 1.95833 1.875 1.375C2.45833 0.791667 3.16667 0.5 4 0.5H8C8.38333 0.5 8.74167 0.571 9.075 0.713C9.40833 0.855 9.71667 1.05067 10 1.3C10.2833 1.05 10.5917 0.854333 10.925 0.713C11.2583 0.571666 11.6167 0.500667 12 0.5H16C16.8333 0.5 17.5417 0.791667 18.125 1.375C18.7083 1.95833 19 2.66667 19 3.5V6.3C19.3 6.58333 19.5417 6.90833 19.725 7.275C19.9083 7.64167 20 8.05 20 8.5V13.5C20 13.7833 19.904 14.021 19.712 14.213C19.52 14.405 19.2827 14.5007 19 14.5C18.7173 14.4993 18.48 14.4033 18.288 14.212C18.096 14.0207 18 13.7833 18 13.5V12.5H2V13.5C2 13.7833 1.904 14.021 1.712 14.213C1.52 14.405 1.28267 14.5007 1 14.5C0.717333 14.4993 0.48 14.4033 0.288 14.212C0.0960001 14.0207 0 13.7833 0 13.5ZM11 5.5H17V3.5C17 3.21667 16.904 2.97933 16.712 2.788C16.52 2.59667 16.2827 2.50067 16 2.5H12C11.7167 2.5 11.4793 2.596 11.288 2.788C11.0967 2.98 11.0007 3.21733 11 3.5V5.5ZM3 5.5H9V3.5C9 3.21667 8.904 2.97933 8.712 2.788C8.52 2.59667 8.28267 2.50067 8 2.5H4C3.71667 2.5 3.47933 2.596 3.288 2.788C3.09667 2.98 3.00067 3.21733 3 3.5V5.5Z"
                fill="var(--c-primary)"
              />
            </svg>
            <p>
              <span>{{ property.bedroom }}</span>
            </p>
          </div>

          <!-- Baths -->
          <div class="tw-flex tw-items-center tw-gap-2">
            <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.1875 14.7501C1.18852 15.2486 1.29483 15.7413 1.49947 16.1959C1.70411 16.6505 2.00247 17.0568 2.375 17.3881V18.9063C2.375 19.0637 2.43756 19.2147 2.54891 19.3261C2.66026 19.4374 2.81128 19.5 2.96875 19.5H4.15625C4.31372 19.5 4.46475 19.4374 4.57609 19.3261C4.68744 19.2147 4.75 19.0637 4.75 18.9063V18.3125H14.25V18.9063C14.25 19.0637 14.3126 19.2147 14.4239 19.3261C14.5353 19.4374 14.6863 19.5 14.8438 19.5H16.0312C16.1887 19.5 16.3397 19.4374 16.4511 19.3261C16.5624 19.2147 16.625 19.0637 16.625 18.9063V17.3881C16.9975 17.0568 17.2959 16.6505 17.5005 16.1959C17.7052 15.7413 17.8115 15.2486 17.8125 14.7501V12.9688H1.1875V14.7501ZM18.4062 10.0001H2.96875V3.07001C2.96909 2.91418 3.01557 2.76193 3.10233 2.63249C3.18909 2.50304 3.31224 2.40218 3.45625 2.34264C3.60026 2.2831 3.75868 2.26754 3.91153 2.29793C4.06437 2.32831 4.20479 2.40328 4.31508 2.51337L5.03018 3.22809C4.54293 4.33691 4.74777 5.4216 5.35006 6.18679L5.34375 6.1931C5.23282 6.30439 5.17054 6.45511 5.17054 6.61224C5.17054 6.76937 5.23282 6.9201 5.34375 7.03139L5.76346 7.45109C5.81859 7.50624 5.88405 7.54999 5.9561 7.57983C6.02815 7.60968 6.10537 7.62504 6.18335 7.62504C6.26133 7.62504 6.33855 7.60968 6.4106 7.57983C6.48265 7.54999 6.54811 7.50624 6.60324 7.45109L10.5135 3.54092C10.5686 3.48579 10.6124 3.42033 10.6422 3.34828C10.672 3.27624 10.6874 3.19902 10.6874 3.12103C10.6874 3.04305 10.672 2.96583 10.6422 2.89379C10.6124 2.82174 10.5686 2.75628 10.5135 2.70115L10.0938 2.28144C9.98241 2.17018 9.83145 2.10768 9.67404 2.10768C9.51664 2.10768 9.36567 2.17018 9.25434 2.28144L9.24803 2.28775C8.48283 1.68547 7.39887 1.48063 6.2893 1.96787L5.57457 1.25278C5.21517 0.893348 4.75726 0.648564 4.25873 0.549391C3.76021 0.450217 3.24347 0.501108 2.77387 0.695627C2.30427 0.890146 1.9029 1.21956 1.62053 1.6422C1.33815 2.06484 1.18746 2.56172 1.1875 3.07001V10.0001H0.59375C0.436278 10.0001 0.285255 10.0627 0.173905 10.174C0.0625556 10.2854 0 10.4364 0 10.5938L0 11.1876C0 11.3451 0.0625556 11.4961 0.173905 11.6074C0.285255 11.7188 0.436278 11.7813 0.59375 11.7813H18.4062C18.5637 11.7813 18.7147 11.7188 18.8261 11.6074C18.9374 11.4961 19 11.3451 19 11.1876V10.5938C19 10.4364 18.9374 10.2854 18.8261 10.174C18.7147 10.0627 18.5637 10.0001 18.4062 10.0001Z"
                fill="var(--c-primary)"
              />
            </svg>
            <p>
              <span>{{ property.bathroom }}</span>
            </p>
          </div>

          <!-- Receptions -->
          <div class="tw-flex tw-items-center tw-gap-2">
            <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.7273 0.5H7.27273C5.98045 0.499879 4.7301 0.948382 3.74448 1.76559C2.75885 2.5828 2.10198 3.71563 1.89091 4.96222C2.01636 4.95037 2.14364 4.94444 2.27273 4.94444C3.3577 4.94444 4.39824 5.36587 5.16544 6.11602C5.93263 6.86616 6.36364 7.88358 6.36364 8.94444V10.2778H13.6364V8.94444C13.6364 8.38771 13.7553 7.83711 13.9855 7.32788C14.2156 6.81866 14.552 6.36201 14.973 5.98718C15.394 5.61234 15.8904 5.32757 16.4304 5.15108C16.9704 4.97458 17.5422 4.91026 18.1091 4.96222C17.898 3.71563 17.2411 2.5828 16.2555 1.76559C15.2699 0.948382 14.0196 0.499879 12.7273 0.5ZM18.1818 6.76667C17.8516 6.70075 17.5105 6.70749 17.1832 6.78638C16.856 6.86527 16.5508 7.01435 16.2897 7.22281C16.0286 7.43127 15.8183 7.69389 15.6738 7.99166C15.5294 8.28943 15.4545 8.61488 15.4545 8.94444V12.9444H13.6364V12.0556H6.36364V12.9444H4.54545V8.94444C4.54545 8.35507 4.30601 7.78984 3.87979 7.3731C3.45357 6.95635 2.87549 6.72222 2.27273 6.72222C1.66996 6.72222 1.09189 6.95635 0.665666 7.3731C0.239447 7.78984 0 8.35507 0 8.94444C0 9.468 0.165455 9.868 0.354545 10.3267C0.609091 10.9453 0.909091 11.6689 0.909091 12.9444V15.6111C0.909091 15.8469 1.00487 16.073 1.17536 16.2397C1.34585 16.4064 1.57708 16.5 1.81818 16.5H18.1818C18.4229 16.5 18.6542 16.4064 18.8246 16.2397C18.9951 16.073 19.0909 15.8469 19.0909 15.6111V12.9444C19.0909 11.6698 19.3909 10.9444 19.6455 10.3267C19.8345 9.868 20 9.468 20 8.94444C20.0001 8.43215 19.8192 7.93556 19.4879 7.53871C19.1565 7.14186 18.6952 6.86912 18.1818 6.76667Z"
                fill="var(--c-primary)"
              />
            </svg>
            <p>
              <span>{{ property.reception }}</span>
            </p>
          </div>
        </div>

        <!-- (Opsiyonel) eşleşme etiketi korunuyor -->
        <div
          v-if="property.match_percentage && !isMatchInformationHidden"
          class="tw-mt-2 tw-flex tw-items-center tw-gap-2"
        >
          <button
            class="n-primary !tw-cursor-default !tw-px-2 !tw-py-1 hover:!tw-bg-[var(--c-secondary)] hover:!tw-text-white"
          >
            <p>{{ property.match_percentage }} MATCH</p>
          </button>
        </div>
      </template>

      <template v-else>
        <p>
          This is a pre-market property. You need to create an account and register to our property alerts in order to
          view it.
        </p>
        <div class="tw-mt-10 tw-flex tw-gap-x-2 tw-pb-3">
          <nuxt-link :to="routes.REGISTER" class="n-secondary tw-w-fit" :external="true">Register</nuxt-link>
          <nuxt-link
            :to="`${routes.PROPERTY_DETAIL.replace(':propertyId', property.property_profile_id)}#login`"
            class="n-secondary tw-w-fit"
            :external="true"
            >Login</nuxt-link
          >
        </div>
      </template>
    </div>
  </div>

   <div
    v-if="version === 'v4'"
    class="property-list-item tw-group tw-relative tw-flex tw-flex-col tw-p-4 tw-text-start md:tw-min-h-[570px]"
    style="border-radius: var(--rounded); color: var(--c-text-primary); border: 1px solid var(--c-border)"
  >
    <nuxt-link
      :external="true"
      :to="property.detail_page_url"
      class="n-link tw-overflow-hidden"
      style="border-radius: var(--rounded)"
    >
      <div style="border-radius: var(--rounded)">
        <library-image :src="property.image" :blur="imageBlurFilter" :pre-market-blur-text="preMarketBlurText" />
      </div>

      <button
        v-if="property.custom_property_status_title && !property.is_locked"
        class="nc-property-image-badge n-primary tw-z-40"
      >
        {{ property.custom_property_status_title }}
      </button>
    </nuxt-link>

    <!-- Video Badge -->
    <div
      v-if="property.featured_video && !property.is_locked"
      class="tw-absolute tw-right-8 tw-top-8 tw-z-40 tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-lg tw-duration-300 hover:tw-scale-95 group-hover:tw-bg-white group-hover:tw-p-3"
      @click="$emit('open-video-popup', property.featured_video)"
    >
      <h6 class="tw-opacity-0 tw-duration-300 group-hover:tw-opacity-100">Play video</h6>
      <div class="tw-rounded-lg tw-bg-white tw-p-3 tw-duration-300 group-hover:tw-bg-transparent group-hover:tw-p-0">
        <!-- (mevcut play ikonunuz) -->
        <!-- ... -->
      </div>
    </div>

    <div class="tw-flex tw-flex-col tw-gap-4 tw-pt-8">
      <!-- Başlık + Sağda Fiyat -->
      <div class="tw-flex tw-items-start tw-justify-between tw-gap-4">
        <h5 class="tw-line-clamp-4   tw-max-h-[5.2rem] tw-flex-1">
          {{ property.advert_heading }}
        </h5>

        <div v-if="!property.is_locked" class="tw-shrink-0 tw-text-right">
          <span v-if="property.price.type.name" class="tw-uppercase tw-opacity-100">
            {{ property.price.type.name }}
          </span>
          <h4 class="tw-mt-1 tw-text-[var(--c-primary)]">
            {{ property.price.price }}
          </h4>
        </div>
      </div>

      <template v-if="!property.is_locked">
        <!-- Adres -->
        <div class="tw-flex tw-h-16 tw-flex-row tw-items-center tw-gap-2">
          <span aria-hidden="true" class="tw-inline-flex tw-items-center">
            <!-- Location SVG (renk: --c-primary) -->
            <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.945 17.18C11.1238 15.2625 15 11.345 15 7.75C15 5.76088 14.2098 3.85322 12.8033 2.4467C11.3968 1.04018 9.48912 0.25 7.5 0.25C5.51088 0.25 3.60322 1.04018 2.1967 2.4467C0.790176 3.85322 2.96403e-08 5.76088 0 7.75C0 11.345 3.875 15.2625 6.055 17.18C6.45264 17.5349 6.967 17.7311 7.5 17.7311C8.033 17.7311 8.54736 17.5349 8.945 17.18ZM5 7.75C5 7.08696 5.26339 6.45107 5.73223 5.98223C6.20107 5.51339 6.83696 5.25 7.5 5.25C8.16304 5.25 8.79893 5.51339 9.26777 5.98223C9.73661 6.45107 10 7.08696 10 7.75C10 8.41304 9.73661 9.04893 9.26777 9.51777C8.79893 9.98661 8.16304 10.25 7.5 10.25C6.83696 10.25 6.20107 9.98661 5.73223 9.51777C5.26339 9.04893 5 8.41304 5 7.75Z"
                fill="var(--c-primary)"
              />
            </svg>
          </span>
          <p class="tw-line-clamp-1">{{ property.display_address }}</p>
        </div>

        <!-- Özellikler -->
        <div class="tw-mt-1 tw-flex tw-flex-row tw-items-center tw-gap-6">
          <!-- Beds -->
          <div class="tw-flex tw-items-center tw-gap-2">
            <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 13.5V8.5C0 8.05 0.0916668 7.64167 0.275 7.275C0.458333 6.90833 0.7 6.58333 1 6.3V3.5C1 2.66667 1.29167 1.95833 1.875 1.375C2.45833 0.791667 3.16667 0.5 4 0.5H8C8.38333 0.5 8.74167 0.571 9.075 0.713C9.40833 0.855 9.71667 1.05067 10 1.3C10.2833 1.05 10.5917 0.854333 10.925 0.713C11.2583 0.571666 11.6167 0.500667 12 0.5H16C16.8333 0.5 17.5417 0.791667 18.125 1.375C18.7083 1.95833 19 2.66667 19 3.5V6.3C19.3 6.58333 19.5417 6.90833 19.725 7.275C19.9083 7.64167 20 8.05 20 8.5V13.5C20 13.7833 19.904 14.021 19.712 14.213C19.52 14.405 19.2827 14.5007 19 14.5C18.7173 14.4993 18.48 14.4033 18.288 14.212C18.096 14.0207 18 13.7833 18 13.5V12.5H2V13.5C2 13.7833 1.904 14.021 1.712 14.213C1.52 14.405 1.28267 14.5007 1 14.5C0.717333 14.4993 0.48 14.4033 0.288 14.212C0.0960001 14.0207 0 13.7833 0 13.5ZM11 5.5H17V3.5C17 3.21667 16.904 2.97933 16.712 2.788C16.52 2.59667 16.2827 2.50067 16 2.5H12C11.7167 2.5 11.4793 2.596 11.288 2.788C11.0967 2.98 11.0007 3.21733 11 3.5V5.5ZM3 5.5H9V3.5C9 3.21667 8.904 2.97933 8.712 2.788C8.52 2.59667 8.28267 2.50067 8 2.5H4C3.71667 2.5 3.47933 2.596 3.288 2.788C3.09667 2.98 3.00067 3.21733 3 3.5V5.5Z"
                fill="var(--c-primary)"
              />
            </svg>
            <p>
              <span>{{ property.bedroom }}</span>
            </p>
          </div>

          <!-- Baths -->
          <div class="tw-flex tw-items-center tw-gap-2">
            <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.1875 14.7501C1.18852 15.2486 1.29483 15.7413 1.49947 16.1959C1.70411 16.6505 2.00247 17.0568 2.375 17.3881V18.9063C2.375 19.0637 2.43756 19.2147 2.54891 19.3261C2.66026 19.4374 2.81128 19.5 2.96875 19.5H4.15625C4.31372 19.5 4.46475 19.4374 4.57609 19.3261C4.68744 19.2147 4.75 19.0637 4.75 18.9063V18.3125H14.25V18.9063C14.25 19.0637 14.3126 19.2147 14.4239 19.3261C14.5353 19.4374 14.6863 19.5 14.8438 19.5H16.0312C16.1887 19.5 16.3397 19.4374 16.4511 19.3261C16.5624 19.2147 16.625 19.0637 16.625 18.9063V17.3881C16.9975 17.0568 17.2959 16.6505 17.5005 16.1959C17.7052 15.7413 17.8115 15.2486 17.8125 14.7501V12.9688H1.1875V14.7501ZM18.4062 10.0001H2.96875V3.07001C2.96909 2.91418 3.01557 2.76193 3.10233 2.63249C3.18909 2.50304 3.31224 2.40218 3.45625 2.34264C3.60026 2.2831 3.75868 2.26754 3.91153 2.29793C4.06437 2.32831 4.20479 2.40328 4.31508 2.51337L5.03018 3.22809C4.54293 4.33691 4.74777 5.4216 5.35006 6.18679L5.34375 6.1931C5.23282 6.30439 5.17054 6.45511 5.17054 6.61224C5.17054 6.76937 5.23282 6.9201 5.34375 7.03139L5.76346 7.45109C5.81859 7.50624 5.88405 7.54999 5.9561 7.57983C6.02815 7.60968 6.10537 7.62504 6.18335 7.62504C6.26133 7.62504 6.33855 7.60968 6.4106 7.57983C6.48265 7.54999 6.54811 7.50624 6.60324 7.45109L10.5135 3.54092C10.5686 3.48579 10.6124 3.42033 10.6422 3.34828C10.672 3.27624 10.6874 3.19902 10.6874 3.12103C10.6874 3.04305 10.672 2.96583 10.6422 2.89379C10.6124 2.82174 10.5686 2.75628 10.5135 2.70115L10.0938 2.28144C9.98241 2.17018 9.83145 2.10768 9.67404 2.10768C9.51664 2.10768 9.36567 2.17018 9.25434 2.28144L9.24803 2.28775C8.48283 1.68547 7.39887 1.48063 6.2893 1.96787L5.57457 1.25278C5.21517 0.893348 4.75726 0.648564 4.25873 0.549391C3.76021 0.450217 3.24347 0.501108 2.77387 0.695627C2.30427 0.890146 1.9029 1.21956 1.62053 1.6422C1.33815 2.06484 1.18746 2.56172 1.1875 3.07001V10.0001H0.59375C0.436278 10.0001 0.285255 10.0627 0.173905 10.174C0.0625556 10.2854 0 10.4364 0 10.5938L0 11.1876C0 11.3451 0.0625556 11.4961 0.173905 11.6074C0.285255 11.7188 0.436278 11.7813 0.59375 11.7813H18.4062C18.5637 11.7813 18.7147 11.7188 18.8261 11.6074C18.9374 11.4961 19 11.3451 19 11.1876V10.5938C19 10.4364 18.9374 10.2854 18.8261 10.174C18.7147 10.0627 18.5637 10.0001 18.4062 10.0001Z"
                fill="var(--c-primary)"
              />
            </svg>
            <p>
              <span>{{ property.bathroom }}</span>
            </p>
          </div>

          <!-- Receptions -->
          <div class="tw-flex tw-items-center tw-gap-2">
            <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.7273 0.5H7.27273C5.98045 0.499879 4.7301 0.948382 3.74448 1.76559C2.75885 2.5828 2.10198 3.71563 1.89091 4.96222C2.01636 4.95037 2.14364 4.94444 2.27273 4.94444C3.3577 4.94444 4.39824 5.36587 5.16544 6.11602C5.93263 6.86616 6.36364 7.88358 6.36364 8.94444V10.2778H13.6364V8.94444C13.6364 8.38771 13.7553 7.83711 13.9855 7.32788C14.2156 6.81866 14.552 6.36201 14.973 5.98718C15.394 5.61234 15.8904 5.32757 16.4304 5.15108C16.9704 4.97458 17.5422 4.91026 18.1091 4.96222C17.898 3.71563 17.2411 2.5828 16.2555 1.76559C15.2699 0.948382 14.0196 0.499879 12.7273 0.5ZM18.1818 6.76667C17.8516 6.70075 17.5105 6.70749 17.1832 6.78638C16.856 6.86527 16.5508 7.01435 16.2897 7.22281C16.0286 7.43127 15.8183 7.69389 15.6738 7.99166C15.5294 8.28943 15.4545 8.61488 15.4545 8.94444V12.9444H13.6364V12.0556H6.36364V12.9444H4.54545V8.94444C4.54545 8.35507 4.30601 7.78984 3.87979 7.3731C3.45357 6.95635 2.87549 6.72222 2.27273 6.72222C1.66996 6.72222 1.09189 6.95635 0.665666 7.3731C0.239447 7.78984 0 8.35507 0 8.94444C0 9.468 0.165455 9.868 0.354545 10.3267C0.609091 10.9453 0.909091 11.6689 0.909091 12.9444V15.6111C0.909091 15.8469 1.00487 16.073 1.17536 16.2397C1.34585 16.4064 1.57708 16.5 1.81818 16.5H18.1818C18.4229 16.5 18.6542 16.4064 18.8246 16.2397C18.9951 16.073 19.0909 15.8469 19.0909 15.6111V12.9444C19.0909 11.6698 19.3909 10.9444 19.6455 10.3267C19.8345 9.868 20 9.468 20 8.94444C20.0001 8.43215 19.8192 7.93556 19.4879 7.53871C19.1565 7.14186 18.6952 6.86912 18.1818 6.76667Z"
                fill="var(--c-primary)"
              />
            </svg>
            <p>
              <span>{{ property.reception }}</span>
            </p>
          </div>
        </div>

        <!-- (Opsiyonel) eşleşme etiketi korunuyor -->
        <div
          v-if="property.match_percentage && !isMatchInformationHidden"
          class="tw-mt-2 tw-flex tw-items-center tw-gap-2"
        >
          <button
            class="n-primary !tw-cursor-default !tw-px-2 !tw-py-1 hover:!tw-bg-[var(--c-secondary)] hover:!tw-text-white"
          >
            <p>{{ property.match_percentage }} MATCH</p>
          </button>
        </div>
      </template>

      <template v-else>
        <p>
          This is a pre-market property. You need to create an account and register to our property alerts in order to
          view it.
        </p>
        <div class="tw-mt-10 tw-flex tw-gap-x-2 tw-pb-3">
          <nuxt-link :to="routes.REGISTER" class="n-secondary tw-w-fit" :external="true">Register</nuxt-link>
          <nuxt-link
            :to="`${routes.PROPERTY_DETAIL.replace(':propertyId', property.property_profile_id)}#login`"
            class="n-secondary tw-w-fit"
            :external="true"
            >Login</nuxt-link
          >
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { PropertyItemComponent } from '~/units/properties/types';
import NcTooltip from '~/components/common/NcTooltip.vue';
import { ROUTES } from '~/constants/ui.constants';

export default defineNuxtComponent({
  name: 'PropertyListItem',

  components: { NcTooltip },

  emits: ['open-video-popup'],

  props: {
    property: {
      required: true,
      type: Object as PropType<PropertyItemComponent>,
    },

    isMatchInformationHidden: {
      required: false,
      type: Boolean,
      default: false,
    },

    version: {
      required: false,
      type: String,
      default: 'v1',
    },

    preMarketPropertyFeature: {
      required: false,
      type: Boolean,
      default: false,
    },

    isLetterPropertyCriteria: {
      required: false,
      type: Boolean,
      default: false,
    },

    preMarketBlurText: {
      required: false,
      type: String,
    },
  },

  computed: {
    routes() {
      return ROUTES;
    },

    imageBlurFilter() {
      if (this.property?.is_locked) {
        return '14px';
      }
      return undefined;
    },
  },
});
</script>
